import { useEffect, useState } from "react";
import {
    FiCreditCard,

    FiCheckCircle,
    FiX,
    FiXCircle,
} from "react-icons/fi";

const initialState = {
    montoPagado: "",
};

export default function PagoCuotaForm({ cuota, onClose, onSave }) {
    const [form, setForm] = useState(initialState);

    useEffect(() => {
        const saldoPendiente =
            Number(cuota?.montoProgramado || 0) - Number(cuota?.montoPagado || 0);

        setForm({
            montoPagado: saldoPendiente > 0 ? saldoPendiente.toFixed(2) : "",
        });
    }, [cuota]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const monto = Number(form.montoPagado || 0);
        const saldoPendiente =
            Number(cuota?.montoProgramado || 0) - Number(cuota?.montoPagado || 0);

        if (monto <= 0) {
            alert("El monto a pagar debe ser mayor a 0");
            return;
        }

        if (monto > saldoPendiente) {
            alert("El monto no puede ser mayor al saldo pendiente de la cuota");
            return;
        }

        await onSave({
            montoPagado: monto,
        });
    };

    const montoProgramado = Number(cuota?.montoProgramado || 0);
    const montoPagadoActual = Number(cuota?.montoPagado || 0);
    const saldoPendiente = Math.max(montoProgramado - montoPagadoActual, 0);

    return (
        <div className="modal-backdrop">
            <div className="modal-card">
                <div className="modal-header">
                    <h3 style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <FiCreditCard size={20} />
                        Pagar cuota #{cuota?.numeroCuota}
                    </h3>

                    <button className="btn-secondary" type="button" onClick={onClose}>
                        <FiX size={16} />
                    </button>
                </div>

                <div className="card-panel" style={{ marginBottom: 16 }}>
                    <p><strong>Monto programado:</strong> S/ {montoProgramado.toFixed(2)}</p>
                    <p><strong>Ya pagado:</strong> S/ {montoPagadoActual.toFixed(2)}</p>
                    <p><strong>Saldo pendiente:</strong> S/ {saldoPendiente.toFixed(2)}</p>
                </div>

                <form className="grid-form" onSubmit={handleSubmit}>
                    <div className="full-width">
                        <label>Monto pagado</label>
                        <input
                            name="montoPagado"
                            type="number"
                            step="0.01"
                            placeholder="0.00"
                            value={form.montoPagado}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-actions full-width">
                        <button className="btn-secondary" type="button" onClick={onClose}>
                            <FiXCircle size={16} />
                            Cancelar
                        </button>
                        <button className="btn-primary" type="submit">
                            <FiCheckCircle size={16} />
                            Registrar pago
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}